import React from 'react';
import { createRoot } from 'react-dom/client';
import { setBooleanFeatureFlagResolver } from '@atlaskit/platform-feature-flags';
import { getDocument } from '@atlaskit/browser-apis';
import { App } from './ui/App';
import { initSentry } from '@atlassian/twg-microsite-experience';
import { initUFO } from './analytics/react-ufo/initUFO';

// Initialise Sentry before rendering the app.
// Disabled in dev environments (localhost / development / local).
initSentry();

// Initialise React UFO before rendering so the React Profiler subscription
// is in place when the first commit happens.
initUFO();

// Brute force new app logos
// eslint-disable-next-line @atlaskit/platform/no-module-level-eval
setBooleanFeatureFlagResolver((flagName) => flagName === 'platform-logo-rebrand');

const rootNode = getDocument()?.getElementById('pillar-root');

if (rootNode) {
	const root = createRoot(rootNode);
	root.render(<App />);
}
